<template>
  <v-layout>
    <v-dialog v-model="show" max-width="800px">
      <v-card>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 order-xs2 order-md1>
                <v-flex xs12>
                  <v-layout wrap>
                    <v-flex xs12 md5>
                      <v-text-field
                        v-model="editedItem.firstName"
                        @keyup.enter="save"
                        label="First Name"
                        ref="focusName"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md7>
                      <v-text-field
                        v-model="editedItem.lastName"
                        @keyup.enter="save"
                        label="Last Name"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md7>
                      <v-text-field
                        v-model="editedItem.email"
                        @keyup.enter="save"
                        label="Email Address"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md5>
                      <v-text-field
                        v-model="editedItem.password"
                        id="password"
                        @keyup.enter="save"
                        label="Password"
                        :append-icon="showpassword ? 'mdi-eye-off' : 'mdi-eye'"
                        :type="showpassword ? 'text' : 'password'"
                        @click:append="() => (showpassword = !showpassword)"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-flex>
              <v-flex
                xs12
                order-xs1
                order-md2
                class="text-xs-center text-sm-center text-md-center text-lg-center"
              >
                <v-flex xs12 text-xs-center>
                  <v-layout wrap>
                    <v-flex xs12 class="font-weight-black">
                      Signature
                    </v-flex>
                    <v-flex xs12>
                      <croppa
                        v-model="croppa"
                        :initial-image="initialImage"
                        :placeholder-font-size="14"
                        :prevent-white-space="true"
                        :disable-drag-and-drop="false"
                        :width="280"
                        :height="100"
                        :zoom-speed="7"
                      >
                      </croppa>
                    </v-flex>
                    <v-flex xs12>
                      <v-btn
                        text
                        icon
                        color="primary"
                        small
                        @click="croppa.rotate(-1)"
                      >
                        <v-icon>mdi-rotate-left</v-icon>
                      </v-btn>
                      <v-btn
                        text
                        icon
                        color="primary"
                        small
                        @click="croppa.rotate()"
                      >
                        <v-icon>mdi-rotate-right</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            v-if="saving"
            @click.stop="show = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="blue darken-1"
            transition="fade-transition"
            v-if="!saving"
            text
            @click.stop="show = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            dark
            transition="fade-transition"
            v-if="saving"
            @click.native="save"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line="true"
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn dark text @click="snackbar.show = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'
import 'vue-croppa/dist/vue-croppa.css'

export default {
  props: ['visible', 'item'],

  data() {
    return {
      croppa: {},
      editedItem: this.item,
      initialImage: null,
      saving: false,
      showpassword: false,
      snackbar: {
        show: false,
        color: '',
        message: '',
      },
    }
  },

  computed: {
    show: {
      get() {
        return this.visible
      },
      set(value) {
        if (!value) {
          this.$emit('close', 'the test')
        }
      },
    },
  },

  watch: {
    visible(val) {
      if (val) {
        this.loadItem()
      }
    },
    editedItem: {
      handler: function() {
        this.saving = true
      },
      deep: true,
    },
  },

  methods: {
    loadItem() {
      this.editedItem = this.item

      let image = new Image()
      image.setAttribute('crossorigin', 'anonymous')
      image.src = this.editedItem.picture

      this.initialImage = image
    },

    async save() {
      this.editedItem.dataUrl = this.croppa.generateDataUrl('image/png', 0.8)

      try {
        const response = await Api().put(
          'update_profile/' + this.editedItem.id,
          this.editedItem
        )
        this.$store.dispatch('setUser', this.editedItem)

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },
  },
}
</script>

<style>
.centered-input input {
  text-align: center;
}

.croppa-container {
  background-color: white;
  border: 3px solid black;
}

.scroll-here {
  overflow: auto;
  height: 340px;
  width: 100%;
}
</style>
